// extracted by mini-css-extract-plugin
export default {"InfoBar":"InfoBar_InfoBar__m6H3N","InfoIcon":"InfoBar_InfoIcon__nJc2d","InfoText":"InfoBar_InfoText__RhDP6"};